import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana99Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1462_13742)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M456.025 297.673L470.337 332.023L424.537 354.922L404.5 311.985C410.225 308.646 424.537 300.536 435.987 294.811C447.437 289.086 454.116 294.334 456.025 297.673Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M361.565 332.022L404.506 311.984L420.246 347.765L368.724 374.959C364.908 368.28 356.698 353.204 354.408 346.334C352.118 339.464 358.703 333.93 361.565 332.022Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M390.187 413.603L368.719 374.959L420.244 347.766L440.281 389.272L390.187 413.603Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M491.807 374.961L470.339 332.023L424.539 354.923L446.008 399.292L491.807 374.961Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M414.52 455.107L390.188 413.601L440.282 389.27L460.319 430.776L414.52 455.107Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M513.274 419.329L491.805 374.961L444.574 399.292L466.043 442.229L513.274 419.329Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M533.313 463.697L513.276 419.328L466.045 442.228L487.514 486.597L533.313 463.697Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M553.352 506.635L533.314 463.697L487.515 486.597L507.552 529.534L553.352 506.635Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M579.11 561.022L553.348 506.635L516.136 525.241L540.467 579.628L579.11 561.022Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M441.712 499.479L414.519 455.11L460.318 430.779L483.218 478.01L441.712 499.479Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M468.904 548.141L441.71 499.478L483.216 478.01L507.547 529.535L468.904 548.141Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M496.099 595.371L468.905 548.14L516.136 525.24L537.605 573.903L496.099 595.371Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M524.725 645.466L496.101 595.373L537.607 573.904L561.938 626.86L524.725 645.466Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M604.872 613.977L579.109 561.021L540.466 579.628L566.228 634.015L604.872 613.977Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M553.35 692.697L524.726 645.466L561.938 626.859L591.994 685.54C585.315 689.357 570.812 697.277 566.232 698.422C561.652 699.567 555.736 695.082 553.35 692.697Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M626.344 661.21L604.875 613.979L566.231 634.016L591.994 685.541C598.196 683.155 612.317 677.526 619.187 674.091C626.057 670.656 626.821 664.072 626.344 661.21Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_13742" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_13742" transform="matrix(0.00196319 0 0 0.00260266 -3.76903 -2.39845)"/>
    </pattern>
    <image id="image0_1462_13742" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};